export default (build) =>
  build.query({
    query: (userId) => ({
      url: `/superadmin/sponsorship/${userId}`,
      method: "GET",
    }),
    providesTags: (result, error, userId) => [
      { type: "UserSponsors", id: userId },
    ],
    transformResponse: (response) => ({
      sponsor: response.sponsor || null,
      sponsoredUsers: response.sponsoredUsers || [],
      sponsoredCount: response.sponsoredCount || 0,
      userId: response.userId,
    }),
  });
